/**
 * @typedef {import('../../services/weather/types/CustomWeather.api_types').Forecast15DayDatapoint} Forecast15DayDatapoint
 */

import { ConditionIcons } from 'components';
import DataGridDisplay from 'components/DataGridDisplay/DataGridDisplay';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaWind } from 'react-icons/fa';
import {
  FaDroplet,
  FaHouseChimney,
  FaTemperatureArrowDown,
  FaTemperatureArrowUp,
} from 'react-icons/fa6';
import { PiWind } from 'react-icons/pi';
import { WiSprinkle } from 'react-icons/wi';

/**
 * Day display for a single 15-day forecast datapoint.
 * @param {{data: Forecast15DayDatapoint, title: string, hideHeader: boolean}} props
 */
export default function Day15Display({ data, title, hideHeader = false }) {
  const conditionId = parseInt(data?.icon || '0');
  return (
    <div className="d-flex flex-grow-1 overflow-auto">
      <DataGridDisplay
        title={!hideHeader ? title : undefined}
        icon={!hideHeader ? <ConditionIcons conditionId={conditionId} size={25} /> : undefined}
      >
        <Container className="justify-content-evenly my-1">
          <Row>
            <Col sm={12} md={4} className="d-flex flex-row">
              <FaTemperatureArrowUp size={21} className="me-2" />
              <div>{`High: ${data.high_temp}°F`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <FaWind size={21} className="me-2" />
              <div>{`Wind: ${data.wind_speed} MPH`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <PiWind size={21} className="me-2" />
              <div>{`Wind Direction: ${data.wind_short}`}</div>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={4} className="d-flex flex-row">
              <FaTemperatureArrowDown size={21} className="me-2" />
              <div>{`Low: ${data.low_temp}°F`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <FaDroplet size={21} className="me-2" />
              <div>{`Humidity: ${data.humidity}%`}</div>
            </Col>

            <Col sm={12} md={4} className="d-flex flex-row">
              <FaDroplet size={21} className="me-2" />
              <div>{`Precipitation: ${data.precip_prob} %`}</div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4} className="d-flex flex-row">
              <FaHouseChimney size={21} className="me-2" />
              <div>{`Feels Like: ${data.comfort}°F`}</div>
            </Col>

            <Col xs={12} sm={4} className="d-flex flex-row">
              <ConditionIcons conditionId={conditionId} size={21} className="me-2" />
              <div>{`Sky: ${data.sky}`}</div>
            </Col>
            <Col xs={12} sm={4} className="d-flex flex-row">
              <WiSprinkle size={21} className="me-2" />
              <div>{`Dew Point: ${data.dew_point}°F`}</div>
            </Col>
          </Row>
        </Container>
      </DataGridDisplay>
    </div>
  );
}
